import React from "react";
import SimpleSectionHeader from "./SimpleSectionHeader";

const CancellationPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Full-width Section Header */}
      <div className="w-full bg-white">
        <SimpleSectionHeader title="Cancellation Policy" />
        <div className="flex justify-center mt-2"></div>
      </div>

      {/* Main Content Container */}
      <div className="py-10 px-4 sm:px-10">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 sm:p-12">
          <p className="text-gray-700 mb-6 text-center">
            Books at Doorsteps believes in helping its customers as far as possible, and has therefore a Liberal Cancellation Policy. Under this:
          </p>

          <ul className="list-disc list-inside text-gray-700 space-y-3">
            <li>
              Cancellations will be considered only if the request is made immediately after placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.
            </li>
            <li>
              The cancellation request may not be entertained if you have ordered any new book which is not in the list and the vendor has initiated the process of shipping it.
            </li>
            <li>
              In case of receipt of damaged or defective book, please report the same to our Customer Service team. This should be reported within the same day of receipt of the book. The request will, however, be entertained once our technical team has checked it.
            </li>
            <li>
              In case you feel that the Book received is not as shown on the site or as per your choice, you must bring it to the notice of our customer service within the same day of receiving the Book. The Customer Service Team, after looking into your complaint, will take an appropriate action.
            </li>
            <li>
              Refund/replacement can be made if the customer establishes that the quality of Book delivered is not good and only if it is approved by our team.
            </li>
            <li>
              In case of any Refunds approved by Books at Doorsteps, it’ll take 6-8 working days for the refund to be processed to the end customer.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;
